var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.47,
    y: 94.25,
    width: 87.56,
    height: 338.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.03,
    y: 94.25,
    width: 21.09,
    height: 338.99,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 105.35,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.03,
    y: 105.35,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 186.98,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.03,
    y: 186.98,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 273.13,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.03,
    y: 273.13,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.14,
    y: 355.22,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.92,
    y: 355.22,
    width: 43.43,
    height: 70.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.93,
    y: 109.99,
    width: 18.52,
    height: 47.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.93,
    y: 138.9,
    width: 18.52,
    height: 18.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.45,157.37a1.22,1.22,0,0,1,0-.24c0-.19,0-.41,0-.7,0-.64,0-1.52,0-2.66,0-2.34,0-5.69-.06-9.88,0-8.43-.07-20.23-.12-33.9l.25.25H388.94c.51-.52.14-.13.25-.24h0v13.56c0,4.39,0,8.61,0,12.63,0,8,0,15.2-.06,21.16l-.18-.18,13.52.1,3.69,0,1,0,.34,0-.31,0-.93,0-3.65,0-13.63.1h-.18v-.18c0-6,0-13.14-.06-21.16,0-4,0-8.24,0-12.63q0-3.28,0-6.69V110h0c.12-.12-.26.24.27-.28H407.7V110c-.05,13.74-.09,25.6-.12,34.07,0,4.17-.05,7.5-.07,9.82q0,1.68,0,2.61c0,.27,0,.49,0,.67A1.48,1.48,0,0,1,407.45,157.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,124.39a77.43,77.43,0,0,1-12.68,0,77.43,77.43,0,0,1,12.68,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,127.69a77.43,77.43,0,0,1-12.68,0,74.57,74.57,0,0,1,12.68,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,131a77.43,77.43,0,0,1-12.68,0,77.43,77.43,0,0,1,12.68,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,134.28a24.37,24.37,0,0,1-7.1,0,24.37,24.37,0,0,1,7.1,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,151.52v1.13H398.1v-1.09a5.35,5.35,0,0,1-2.57-.77l.66-1.48a4.53,4.53,0,0,0,2.34.7c.84,0,1.16-.24,1.16-.58,0-1.13-4-.31-4-3,0-1.12.8-2.06,2.45-2.27V143.1h1.22v1.09a5,5,0,0,1,2.06.6l-.62,1.5a4.15,4.15,0,0,0-2-.55c-.85,0-1.15.28-1.15.64,0,1.09,4,.27,4,2.9C401.67,150.35,400.9,151.29,399.32,151.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1,94.25a60.62,60.62,0,0,1,.26,7.87,60.49,60.49,0,0,1-.26,7.87,60.49,60.49,0,0,1-.26-7.87A60.62,60.62,0,0,1,398.1,94.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.2,
    y: 117.08,
    width: 7.58,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,337.52a5.74,5.74,0,0,0-4.47,5.85c.24,6.13,1,16.86,3.44,23.15,3.55,9.17,4.44,12.73,11.24,12.43s102.68,0,102.68,0,8.58.3,12.13-12.13,11.54-60.66,7.1-69.24-23.37-11.25-31.66-10.66-23.65-1.8-43.78,23.36l-19.84,22.63A185.92,185.92,0,0,0,579,337.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.4,299.84,626.24,353.5H590.73s-2.8-18-8-16.74c0,0,26-4.33,33.12-3.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.31,379.36s3.85-5.05,5.62-14.22,6.22-28.71-2.81-28.41c0,0,26.19.83,31.51-3.43s20.27-33.07,20.27-33.07,1.43,10.84-.79,26.83-4.68,34.53-7.05,40.15-4.14,12.15-12.13,12.13S657.31,379.36,657.31,379.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.42,379s1.76,5.28,12.93,5.28h76.2s9.67-.21,12.38-5.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.72 382.48 576.51 432.83 578.66 432.83 610.79 382.48 604.72 382.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.46,381.6c0,.69-7.05,51.23-7.05,51.23h2l12.73-50.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647,382.48c-.19,1.77,8.43,50.35,8.43,50.35h2.74l-3.53-50.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.76 382.48 701.49 432.83 704.24 432.83 677.4 382.48 669.76 382.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.93,365.14a1.1,1.1,0,0,1,.05-.28c0-.21.11-.48.19-.81.17-.74.4-1.78.7-3.1a81,81,0,0,0,1.7-11.55,25.66,25.66,0,0,0-.55-8,6.37,6.37,0,0,0-2.23-3.65c-1.19-.92-2.86-.89-4.42-.64a9.45,9.45,0,0,0-4.38,2.1,14.87,14.87,0,0,0-3.25,4,30.44,30.44,0,0,0-3.45,10.33l0,.23h-1L607,353.69l-11.9-.09-3.23-.05-.84,0-.29,0,.29,0,.84,0,3.23-.05,11.9-.08,39.27-.08H647l-.26.23A30.85,30.85,0,0,1,650.3,343a15,15,0,0,1,3.38-4.1,9.9,9.9,0,0,1,4.61-2.19,8.56,8.56,0,0,1,1.24-.14l.61,0,.63.05a5.56,5.56,0,0,1,1.21.26c.19.07.37.18.56.27a2.27,2.27,0,0,1,.52.32,6.86,6.86,0,0,1,2.38,3.9,26.28,26.28,0,0,1,.5,8.12A75.4,75.4,0,0,1,664.07,361c-.32,1.34-.6,2.38-.8,3.08l-.24.79A1.36,1.36,0,0,1,662.93,365.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.05,
    y: 351.19,
    width: 17.87,
    height: 45.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.05,
    y: 379.09,
    width: 17.87,
    height: 17.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.92,396.92a1.35,1.35,0,0,1,0-.24V396c0-.62,0-1.48,0-2.57,0-2.26,0-5.49-.07-9.54,0-8.13-.07-19.53-.12-32.71l.25.25H671.05c.52-.52.14-.14.26-.25h0v6.63c0,2.19,0,4.35,0,6.47,0,4.23,0,8.3,0,12.18,0,7.74,0,14.67-.06,20.43l-.18-.18,13,.1,3.56,0,.94,0,.33,0-.3,0-.9,0-3.52,0-13.15.1h-.18v-.18c0-5.76,0-12.69-.06-20.43,0-3.88,0-7.95,0-12.18v-13.1h0c.11-.12-.27.25.26-.27h18.12v.25c0,13.25-.09,24.7-.12,32.88,0,4,0,7.24-.07,9.48q0,1.62,0,2.52c0,.26,0,.47,0,.64S688.92,396.92,688.92,396.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686,365.08a72.16,72.16,0,0,1-12.24,0,72.16,72.16,0,0,1,12.24,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686,368.26a72.16,72.16,0,0,1-12.24,0,72.16,72.16,0,0,1,12.24,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686,371.45a72.16,72.16,0,0,1-12.24,0,69.5,69.5,0,0,1,12.24,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.63,374.63a22.69,22.69,0,0,1-6.85,0,22.69,22.69,0,0,1,6.85,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.07,391.27v1.09h-1.18v-1.05a5.19,5.19,0,0,1-2.48-.75l.64-1.43a4.36,4.36,0,0,0,2.27.68c.8,0,1.11-.23,1.11-.56,0-1.09-3.9-.3-3.9-2.85,0-1.08.77-2,2.36-2.18v-1.08h1.18v1.06a4.82,4.82,0,0,1,2,.57l-.6,1.45a3.94,3.94,0,0,0-1.9-.53c-.81,0-1.11.27-1.11.62,0,1.05,3.9.26,3.9,2.79C683.35,390.14,682.6,391,681.07,391.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.9,336a56.44,56.44,0,0,1,.26,7.6,56.44,56.44,0,0,1-.26,7.6,54.52,54.52,0,0,1-.26-7.6A54.52,54.52,0,0,1,679.9,336Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674.2,
    y: 358.02,
    width: 7.32,
    height: 2.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.09,
    y: 65.7,
    width: 6.15,
    height: 105.24,
    transform: "translate(0.17 -0.99) rotate(0.08)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.89,
    y: 67.96,
    width: 124.19,
    height: 100.84,
    transform: "translate(0.17 -0.9) rotate(0.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.37,171.25l-128.91-.18.15-105.56,128.91.19Zm-124.19-4.88,119.48.16.14-96.13-119.48-.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.56,
    y: 104.77,
    width: 34.81,
    height: 27.1,
    transform: "translate(0.17 -0.9) rotate(0.08)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.82,
    y: 80.81,
    width: 16.94,
    height: 43.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.82,
    y: 107.25,
    width: 16.94,
    height: 16.89,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.75,124.14a2.07,2.07,0,0,1,0-.23l0-.63c0-.59,0-1.4,0-2.44,0-2.14,0-5.21-.07-9,0-7.71-.07-18.5-.12-31l.25.25H668.82c.52-.53.14-.14.26-.25h0v6.28c0,2.08,0,4.12,0,6.13,0,4,0,7.87,0,11.54,0,7.34,0,13.9-.06,19.36l-.18-.18,12.35.1,3.38,0,.89,0a1.92,1.92,0,0,1,.31,0,1.21,1.21,0,0,1-.28,0l-.85,0-3.34,0-12.46.1h-.18v-.18c0-5.46,0-12-.06-19.36,0-3.67,0-7.53,0-11.54V80.83h0c.11-.12-.27.24.26-.27H686v.25c0,12.56-.09,23.41-.11,31.16,0,3.81-.06,6.85-.07,9,0,1,0,1.8,0,2.38,0,.24,0,.44,0,.61S685.76,124.15,685.75,124.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,94a64.82,64.82,0,0,1-11.6,0A64.82,64.82,0,0,1,683,94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,97a64.82,64.82,0,0,1-11.6,0A64.82,64.82,0,0,1,683,97Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,100a64.82,64.82,0,0,1-11.6,0,64.82,64.82,0,0,1,11.6,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.9,103a20.44,20.44,0,0,1-6.5,0,20.44,20.44,0,0,1,6.5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.31,118.79v1H677.2v-1a5.06,5.06,0,0,1-2.35-.71l.6-1.36a4.11,4.11,0,0,0,2.15.64c.76,0,1.06-.21,1.06-.53,0-1-3.7-.27-3.7-2.69,0-1,.73-1.89,2.24-2.07v-1h1.11v1a4.4,4.4,0,0,1,1.89.55l-.57,1.36a3.87,3.87,0,0,0-1.8-.5c-.77,0-1.05.26-1.05.59,0,1,3.69.25,3.69,2.64C680.47,117.72,679.76,118.58,678.31,118.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.2,66.4a49.06,49.06,0,0,1,.26,7.2,49.14,49.14,0,0,1-.26,7.21,50.87,50.87,0,0,1-.26-7.21A50.78,50.78,0,0,1,677.2,66.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.81,
    y: 87.28,
    width: 6.93,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.67,145.17s-15.16,60.64-15.85,113,0,146.08,0,146.08H518.5l0-148.31c0-45.23-10.13-84.32-16.94-110.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.88,
    y: 403.19,
    width: 2.63,
    height: 29.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,433.73h72.62s-8.4-5.65-37.44-5.65S452,433.73,452,433.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.01,
    y: 160.28,
    width: 16.94,
    height: 43.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.01,
    y: 186.72,
    width: 16.94,
    height: 16.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.94,203.61a2,2,0,0,1,0-.22c0-.17,0-.38,0-.64,0-.59,0-1.4,0-2.44,0-2.14,0-5.21-.07-9,0-7.71-.07-18.5-.11-31l.24.25H484c.52-.52.14-.14.26-.25h0v6.29q0,3.1,0,6.12c0,4,0,7.87,0,11.54,0,7.34,0,13.91-.06,19.36l-.18-.18,12.36.1,3.37,0,.89,0,.31,0s-.08,0-.27,0l-.86,0-3.34,0-12.46.09h-.18v-.18c0-5.45,0-12-.06-19.36,0-3.67,0-7.53,0-11.54V160.3h0c.12-.12-.26.25.26-.27H501.2v.25c0,12.56-.08,23.41-.11,31.16,0,3.81-.06,6.86-.07,9,0,1,0,1.8,0,2.38l0,.61C501,203.55,501,203.62,500.94,203.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.19,173.44a64.71,64.71,0,0,1-11.59,0,64.71,64.71,0,0,1,11.59,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.19,176.46a64.71,64.71,0,0,1-11.59,0,64.71,64.71,0,0,1,11.59,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.19,179.47a64.71,64.71,0,0,1-11.59,0,64.71,64.71,0,0,1,11.59,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.09,182.49a20.38,20.38,0,0,1-6.49,0,20.38,20.38,0,0,1,6.49,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5,198.26v1h-1.11v-1a5.06,5.06,0,0,1-2.35-.71l.6-1.35a4.14,4.14,0,0,0,2.15.64c.76,0,1.06-.22,1.06-.53,0-1-3.7-.28-3.7-2.7,0-1,.73-1.88,2.24-2.07v-1h1.11v1a4.54,4.54,0,0,1,1.89.55l-.57,1.37A3.77,3.77,0,0,0,493,193c-.77,0-1,.26-1,.59,0,1,3.69.25,3.69,2.65C495.66,197.19,495,198.05,493.5,198.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.4,145.88a50.66,50.66,0,0,1,.26,7.2,50.78,50.78,0,0,1-.26,7.2,48.17,48.17,0,0,1-.27-7.2A48.06,48.06,0,0,1,492.4,145.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 166.76,
    width: 6.93,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712,433.65c0,.14-151.8.26-339,.26S34,433.79,34,433.65s151.77-.26,339.06-.26S712,433.5,712,433.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.39,304.32s-2.73-34.51-28.84-66.22-50.18-30.39-50.18-30.39,27.09-10.19,55.42,23.76S453.39,304.32,453.39,304.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,180.77c-.57-1,1.69,76.79,1.69,76.79l6,55.76s4.67-41.22,3.7-62.37S452.33,189.34,447.2,180.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.13,181s-11.78,7.32-15.66,64.24c-3,43.62-4.94,60.32-5.57,65.77a7.47,7.47,0,0,0,0,2.34s14.3-40.41,18.53-62.27S471.93,197.62,476.13,181Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.48,325.06c-.06,1.42,4.75-18.67,29.77-43.23,23.28-22.86,33.69-23.69,33.69-23.69s-24.05,3.18-40.19,20.34C466.5,293.63,458.18,310.61,457.48,325.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.65,347.61c-2.66-9.91-5.62-19.92-11.28-28.48s-14.44-15.59-24.63-16.76c16.36,12.14,28.27,26.09,35.91,45.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.92,308.5s-4.35-38.56-31.92-50.75c-15.37-6.8-38.3-2.69-38.3-2.69s28.78,3.81,39.44,10.62S454.92,308.5,454.92,308.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,421a1.47,1.47,0,0,1-.05-.49c0-.38,0-.85,0-1.42,0-1.33,0-3.15-.06-5.45,0-4.84,0-11.67,0-20.07.08-17,.19-40.39.31-66.2q0-4.85.07-9.57c0-1.58,0-3.14,0-4.69,0-.81,0-1.52.08-2.39s.37-1.5.5-2.26c.61-3,1-5.93,1.59-8.83s1.19-5.68,1.77-8.42c1.11-5.49,2.33-10.67,3.2-15.57L463.88,262c.85-4.15,1.28-8,1.79-11.28s.9-6.16,1.24-8.54.62-4.07.82-5.39c.08-.57.14-1,.2-1.41a1.69,1.69,0,0,1,.1-.47,1.53,1.53,0,0,1,0,.49c0,.38,0,.84-.09,1.41-.1,1.25-.34,3.07-.62,5.42s-.65,5.26-1.07,8.57-.83,7.16-1.63,11.32-1.53,8.76-2.39,13.66-2,10.11-3.11,15.61q-.84,4.11-1.73,8.42c-.58,2.85-.95,5.82-1.56,8.84-.13.74-.37,1.55-.49,2.22a20.31,20.31,0,0,0-.06,2.24l0,4.68q0,4.73-.07,9.57c-.24,25.81-.45,49.17-.61,66.2-.13,8.4-.23,15.23-.31,20.06-.05,2.3-.1,4.12-.13,5.45,0,.58-.05,1-.07,1.42A2.75,2.75,0,0,1,454,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.68,313.36c.15.05-.35,1.94-1.1,5s-1.7,7.29-2.5,12-1.34,9.05-1.7,12.18-.58,5.06-.73,5.06-.18-2,0-5.13A110.6,110.6,0,0,1,456,330.2a97.66,97.66,0,0,1,2.83-12C459.8,315.13,460.55,313.32,460.68,313.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.58,433.65c5.92-5.3,6.9-14.44,4.83-22.11s-6.6-14.4-10.38-21.39L443.47,390c-3.87,6.94-8.51,13.6-10.68,21.24s-1.32,16.8,4.53,22.18Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.88,212.71a3.1,3.1,0,0,1,.18,1c.08.76.18,1.68.3,2.79.24,2.42.52,5.93.82,10.27.6,8.68,1.19,20.69,1.6,34s.49,25.3.32,34c-.07,4.36-.21,7.88-.35,10.31-.08,1.11-.14,2-.2,2.79a4,4,0,0,1-.14,1,3.28,3.28,0,0,1-.07-1V305c0-2.59,0-6.07,0-10.29,0-8.69-.24-20.7-.63-34s-.88-25.26-1.29-34c-.19-4.21-.36-7.69-.48-10.28,0-1.12-.08-2-.1-2.8A3.09,3.09,0,0,1,451.88,212.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.53,245.33a9.41,9.41,0,0,1,1.3,1.79c.79,1.18,1.85,2.94,3.1,5.15a140.64,140.64,0,0,1,14.29,36.91c.57,2.47,1,4.49,1.18,5.89a8,8,0,0,1,.24,2.2c-.16,0-.83-3-2.14-7.91a178.62,178.62,0,0,0-14.23-36.73C436,248.14,434.39,245.42,434.53,245.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.68,260.52a6.4,6.4,0,0,1,2.07,1,41.87,41.87,0,0,1,5.12,3.51,69.58,69.58,0,0,1,6.81,6.17,46.74,46.74,0,0,1,6.72,9.07,156.14,156.14,0,0,1,9.07,18.27c1,2.4,1.78,4.37,2.28,5.74a9.07,9.07,0,0,1,.67,2.17,9.63,9.63,0,0,1-1.05-2c-.7-1.53-1.57-3.4-2.58-5.6-2.22-4.7-5.26-11.22-9.29-18a49,49,0,0,0-6.52-8.94,79.15,79.15,0,0,0-6.59-6.26,58,58,0,0,0-4.86-3.74A18.43,18.43,0,0,1,422.68,260.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.63,
    y: 227.18,
    width: 2.3,
    height: 39.3,
    transform: "translate(0.35 -0.27) rotate(0.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.25,
    y: 228.03,
    width: 46.38,
    height: 37.66,
    transform: "translate(0.35 -0.23) rotate(0.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.48,266.6l-48.14-.07.06-39.42,48.14.07Zm-46.38-1.83,44.62.07.05-35.9-44.62-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.38,
    y: 240.75,
    width: 16.11,
    height: 12.55,
    transform: "translate(0.35 -0.23) rotate(0.08)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.49,
    y: 74.2,
    width: 7.27,
    height: 124.35,
    transform: "translate(0.19 -0.4) rotate(0.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 76.88,
    width: 146.75,
    height: 119.16,
    transform: "translate(0.19 -0.29) rotate(0.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,198.93l-152.32-.21L132,74l152.32.22Zm-146.74-5.77,141.18.19.16-113.59-141.18-.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.13,
    y: 92.87,
    width: 108.37,
    height: 84.37,
    transform: "translate(0.19 -0.29) rotate(0.08)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.26,
    y: 92.05,
    width: 20.01,
    height: 51.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.26,
    y: 123.3,
    width: 20.01,
    height: 19.96,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,143.26a1.33,1.33,0,0,1,0-.26c0-.2,0-.44,0-.75,0-.69,0-1.65,0-2.88,0-2.52,0-6.14-.07-10.68,0-9.1-.07-21.86-.11-36.64l.25.25h-20c.51-.52.14-.13.26-.25v14.68c0,4.74,0,9.31,0,13.65,0,8.66,0,16.43-.05,22.87l-.18-.18,14.61.1,4,0,1.05,0,.37,0a2.14,2.14,0,0,1-.34,0l-1,0-3.95,0-14.71.1h-.19v-.18c0-6.44,0-14.21-.05-22.87,0-4.34,0-8.91,0-13.65V92.06c.12-.11-.26.25.27-.27h20.26v.25c0,14.85-.09,27.67-.12,36.81,0,4.52-.05,8.12-.07,10.63,0,1.2,0,2.15,0,2.82l0,.72A1.66,1.66,0,0,1,269.28,143.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,107.61a46,46,0,0,1-6.86.26,46,46,0,0,1-6.85-.26,46,46,0,0,1,6.85-.26A46,46,0,0,1,266,107.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,111.17a44.48,44.48,0,0,1-6.86.26,44.39,44.39,0,0,1-6.85-.26,46,46,0,0,1,6.85-.26A46,46,0,0,1,266,111.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,114.74a46,46,0,0,1-6.86.26,46,46,0,0,1-6.85-.26,44.39,44.39,0,0,1,6.85-.26A44.48,44.48,0,0,1,266,114.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,118.3a28.49,28.49,0,0,1-7.68,0,28.49,28.49,0,0,1,7.68,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49,136.94v1.22h-1.32V137a5.9,5.9,0,0,1-2.78-.83l.71-1.61a4.86,4.86,0,0,0,2.54.76c.9,0,1.25-.25,1.25-.63,0-1.22-4.37-.33-4.37-3.18,0-1.21.87-2.23,2.65-2.45v-1.21h1.32V129a5.32,5.32,0,0,1,2.23.64l-.67,1.62a4.53,4.53,0,0,0-2.14-.59c-.91,0-1.24.3-1.24.69,0,1.17,4.36.29,4.36,3.13C263,135.67,262.2,136.68,260.49,136.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.17,75c.15,0,.26,4.93.26,11s-.11,11-.26,11-.26-4.93-.26-11S259,75,259.17,75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 99.71,
    width: 8.19,
    height: 2.82,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.03,
    y: 383.77,
    width: 123.86,
    height: 11.02,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.14 391.1 589.13 434.49 596 434.49 639.71 391.1 616.14 391.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "697.18 391.1 724.19 434.49 717.32 434.49 673.61 391.1 697.18 391.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.91,
    y: 294.04,
    width: 3.68,
    height: 87.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.52 383.68 662.91 379.27 666.59 379.27 688.09 383.68 643.52 383.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644 263.59 621.66 303.12 708.34 303.12 686.24 263.59 644 263.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644,263.59l.74,0,2.21,0,8.45-.06,30.84-.1h.12l.06.11L708.56,303l.21.38H686.06l-64.4-.05h-.36l.17-.31,16.38-28.77,4.54-7.92,1.19-2.06.42-.68s-.12.26-.38.74-.66,1.2-1.16,2.11l-4.46,8-16.16,28.79-.18-.32,64.4-.05h22.28l-.22.38-22.06-39.56.18.1-30.75-.09-8.49-.06-2.22,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.28,
    y: 311.9,
    width: 13.95,
    height: 35.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.28,
    y: 333.68,
    width: 13.95,
    height: 13.92,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.24,347.6a6.87,6.87,0,0,1,0-.71q0-.75,0-2c0-1.79,0-4.31-.07-7.46,0-6.36-.07-15.24-.12-25.52l.25.25h-14c.51-.52.14-.14.25-.25h0v10.22c0,3.3,0,6.49,0,9.51,0,6,0,11.45-.06,16l-.18-.18,10.18.1,2.78.05.74,0h.26s-.07,0-.23,0l-.7,0-2.74.05-10.29.1h-.18v-.19c0-4.5,0-9.91-.05-16,0-3,0-6.21,0-9.51v-5c0-.86,0-1.72,0-2.59v-2.59h0c.12-.12-.26.25.27-.27h14.2v.25c0,10.35-.09,19.29-.12,25.69,0,3.13,0,5.63-.07,7.4,0,.82,0,1.47,0,2A4.79,4.79,0,0,1,691.24,347.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,322.75a44,44,0,0,1-9.55,0,44,44,0,0,1,9.55,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,325.23a44,44,0,0,1-9.55,0,44,44,0,0,1,9.55,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,327.72a44,44,0,0,1-9.55,0,42.36,42.36,0,0,1,9.55,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.77,330.2a7.22,7.22,0,0,1-2.68.26,7.14,7.14,0,0,1-2.67-.26,7.14,7.14,0,0,1,2.67-.26A7.22,7.22,0,0,1,684.77,330.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.11,343.2v.85h-.92v-.82a4.16,4.16,0,0,1-1.94-.59l.5-1.11a3.43,3.43,0,0,0,1.77.52c.63,0,.87-.17.87-.43,0-.85-3-.23-3-2.22,0-.85.61-1.56,1.85-1.71v-.84h.92v.82a3.8,3.8,0,0,1,1.55.45l-.46,1.13a3.14,3.14,0,0,0-1.49-.41c-.63,0-.86.21-.86.48,0,.82,3,.21,3,2.18C686.89,342.31,686.3,343,685.11,343.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.19,300a67.87,67.87,0,0,1,0,11.87,67.87,67.87,0,0,1,0-11.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679.75,
    y: 317.24,
    width: 5.71,
    height: 1.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.83,394.88c0,.14-27.7.26-61.87.26s-61.88-.12-61.88-.26,27.7-.26,61.88-.26S719.83,394.74,719.83,394.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 705.91,
    y: 393.3,
    width: 12.26,
    height: 31.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 705.91,
    y: 412.44,
    width: 12.26,
    height: 12.23,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.17,424.67a5.4,5.4,0,0,1,0-.63c0-.45,0-1,0-1.77,0-1.58,0-3.8-.07-6.56,0-5.59-.07-13.39-.12-22.41l.25.25H705.91c.52-.53.15-.14.26-.26h0v9c0,2.9,0,5.7,0,8.36,0,5.3,0,10-.06,14l-.18-.18,8.93.1,2.45,0,.65,0,.23,0a5.65,5.65,0,0,1-.81,0l-2.41,0-9,.1h-.18v-.18c0-4,0-8.71-.06-14,0-2.66,0-5.46,0-8.36,0-1.46,0-2.94,0-4.44v-4.55h0l.26-.26h12.52v.25c0,9.09-.08,16.94-.11,22.58,0,2.74-.06,4.94-.07,6.5,0,.72,0,1.29,0,1.72A2.09,2.09,0,0,1,718.17,424.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.18,402.83a34,34,0,0,1-8.39,0,34,34,0,0,1,8.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.18,405a34,34,0,0,1-8.39,0,34,34,0,0,1,8.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.18,407.19a32.72,32.72,0,0,1-8.39,0,34,34,0,0,1,8.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.49,409.38a10.75,10.75,0,0,1-4.7,0,10.75,10.75,0,0,1,4.7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.79,420.8v.74H712v-.72a3.52,3.52,0,0,1-1.7-.51l.44-1a2.88,2.88,0,0,0,1.55.46c.55,0,.77-.15.77-.38,0-.75-2.68-.2-2.68-2,0-.74.53-1.37,1.62-1.5v-.74h.81V416a3.23,3.23,0,0,1,1.36.39l-.41,1a2.78,2.78,0,0,0-1.3-.36c-.56,0-.76.19-.76.42,0,.72,2.67.18,2.67,1.92C714.35,420,713.84,420.64,712.79,420.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712,383.77a43.79,43.79,0,0,1,0,9.53,43.79,43.79,0,0,1,0-9.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.08,
    y: 397.99,
    width: 5.02,
    height: 1.73,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Armchair--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.43 382.87 334.95 433.33 339.05 433.33 372.12 387.24 361.43 382.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.76 386.49 393.87 433.13 397.97 433.13 414.54 386.49 402.76 386.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33,355.85l94.18-16.27A7.44,7.44,0,0,1,499,345h0L398.05,362.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.31 350.17 501.43 433.69 507.32 433.69 481.23 348.11 469.31 350.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.16,269.44a7.76,7.76,0,0,0-3.59,9.58c7.15,18.86,28.89,75.83,37.53,98.47A14.78,14.78,0,0,0,363.78,387c17.71.18,54.18.48,71.83.11a10.44,10.44,0,0,0,10.23-10.44h0a10.45,10.45,0,0,0-11.25-10.41L376.66,371a13.49,13.49,0,0,1-13.6-8.39L327,273.2a7.76,7.76,0,0,0-10.79-3.76Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,366.27h61.89a8.61,8.61,0,0,1,8.61,8.61v3.8a8.61,8.61,0,0,1-8.61,8.61H436a0,0,0,0,1,0,0v-21a0,0,0,0,1,0,0Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,268.52h60.33a7.53,7.53,0,0,1,6.85,4.42l42.44,93.84L379,377.7l-19.55-6.63Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.16,269.44a7.76,7.76,0,0,0-3.59,9.58c7.15,18.86,28.89,75.83,37.53,98.47A14.78,14.78,0,0,0,363.78,387c17.71.18,54.18.48,71.83.11a10.44,10.44,0,0,0,10.23-10.44h0a10.45,10.45,0,0,0-11.25-10.41L376.66,371a13.49,13.49,0,0,1-13.6-8.39L327,273.2a7.76,7.76,0,0,0-10.79-3.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,355.85,431,339.58a7.45,7.45,0,0,1,8.47,5.46h0L338.53,362.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.79 350.17 441.91 433.69 447.8 433.69 421.71 348.11 409.79 350.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 363.55,
    width: 13.95,
    height: 35.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 385.33,
    width: 13.95,
    height: 13.92,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,399.26s0-.26,0-.72,0-1.17,0-2c0-1.78,0-4.31-.07-7.46,0-6.36-.07-15.24-.12-25.52l.25.25H374.33c.52-.52.15-.14.26-.25h0v10.22c0,3.3,0,6.49,0,9.51,0,6,0,11.45-.06,16l-.18-.19,10.17.1,2.79.05.73,0a.76.76,0,0,1,.26,0h-.22l-.7,0-2.75,0-10.28.1h-.18v-.18c0-4.51,0-9.92-.06-16,0-3,0-6.21,0-9.51,0-1.65,0-3.34,0-5v-5.18h0c.12-.12-.26.25.26-.27h14.21v.25c0,10.35-.08,19.29-.11,25.69,0,3.13-.06,5.63-.07,7.4,0,.82,0,1.48,0,2A2.91,2.91,0,0,1,388.28,399.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,374.4a44.07,44.07,0,0,1-9.56,0,44.07,44.07,0,0,1,9.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,376.88a44.07,44.07,0,0,1-9.56,0,44.07,44.07,0,0,1,9.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,379.37a44.07,44.07,0,0,1-9.56,0,42.45,42.45,0,0,1,9.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.81,381.85a7.14,7.14,0,0,1-2.67.26,7.22,7.22,0,0,1-2.68-.26,7.22,7.22,0,0,1,2.68-.26A7.14,7.14,0,0,1,381.81,381.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.16,394.85v.85h-.92v-.82a4.12,4.12,0,0,1-1.94-.59l.5-1.11a3.37,3.37,0,0,0,1.77.52c.62,0,.87-.17.87-.43,0-.85-3.05-.23-3.05-2.22,0-.85.61-1.56,1.85-1.71v-.84h.92v.82a3.84,3.84,0,0,1,1.55.45l-.47,1.13a3.22,3.22,0,0,0-1.48-.41c-.64,0-.87.21-.87.48,0,.82,3,.21,3,2.18C383.93,394,383.35,394.67,382.16,394.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,351.68a67.87,67.87,0,0,1,0,11.87,67.87,67.87,0,0,1,0-11.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.79,
    y: 368.89,
    width: 5.71,
    height: 1.97,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dresser--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "125.12 433.56 141.56 396.84 151.69 396.84 127.99 433.56 125.12 433.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,316.45c-2.31-11.67-8.67-14.85-17.34-18.9s-4.91-13.29-4.91-13.29h-5.06s3.76,9.25-4.91,13.29-15,7.23-17.34,18.9,3.76,27.31,3.76,27.31l21-.26,21,.26S291.33,328.12,289,316.45Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,286.84h79.16l-20-46H242.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.68 397.46 130.46 397.46 110.42 397.46 110.42 343.76 334.68 343.76 334.68 397.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.48,393.59s0-.29,0-.83,0-1.36,0-2.4c0-2.12,0-5.21-.05-9.18,0-8-.06-19.45-.1-33.65l.19.19-107.81.07h0l.26-.26c0,16.16,0,31.73,0,46.06l-.25-.25,77.31.12,22.41.07,6,0h1.56l.54,0H331l-1.53,0-5.95,0-22.35.07-77.48.12h-.25v-.25c0-14.33,0-29.9,0-46.06v-.26h.27l107.81.08h.18v.18c0,14.24-.07,25.77-.1,33.76,0,4,0,7,0,9.14,0,1,0,1.82,0,2.37S331.48,393.59,331.48,393.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47,370.42a3.39,3.39,0,1,1-3.39-3.4A3.39,3.39,0,0,1,281.47,370.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,393.59s0-.29,0-.83,0-1.36,0-2.4c0-2.12,0-5.21,0-9.18,0-8-.06-19.45-.1-33.65l.18.19-107.81.07h0l.26-.26c0,16.16,0,31.73,0,46.06l-.24-.25,77.31.12,22.41.07,6,0h1.56l.53,0h-.5l-1.53,0-6,0-22.35.07-77.48.12h-.25v-.25c0-14.33,0-29.9,0-46.06v-.26h.26l107.81.08h.19v.18c0,14.24-.08,25.77-.1,33.76,0,4,0,7-.05,9.14,0,1,0,1.82,0,2.37S221.87,393.59,221.87,393.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.87,370.42a3.4,3.4,0,1,1-3.39-3.4A3.39,3.39,0,0,1,171.87,370.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.45 340.76 145.45 334.06 155.02 334.06 155.02 341.33 145.45 340.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15,309.17V342.1h17.42V309.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 319.89,
    width: 11.87,
    height: 20.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.38 339.8 136.64 344.39 207.67 344.39 210.35 339.8 133.38 339.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.29,
    y: 250,
    width: 13.16,
    height: 33.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.29,
    y: 270.54,
    width: 13.16,
    height: 13.13,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.45,283.67a6.33,6.33,0,0,1,0-.68c0-.47,0-1.1,0-1.9,0-1.68,0-4.06-.07-7,0-6-.07-14.37-.12-24.06l.25.25H269.29c.52-.52.15-.14.26-.25h0v9.63c0,3.11,0,6.11,0,9,0,5.69,0,10.79-.06,15l-.18-.18,9.59.1,2.63,0,.69,0,.25,0s-.29,0-.87,0l-2.59,0-9.7.1h-.18v-.18c0-4.25,0-9.35-.06-15,0-2.86,0-5.86,0-9,0-1.56,0-3.15,0-4.76V250h0c.12-.12-.26.25.26-.27H282.7V250c-.05,9.75-.09,18.19-.12,24.23,0,2.94-.05,5.3-.07,7,0,.77,0,1.38,0,1.84A4.52,4.52,0,0,1,282.45,283.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,260.23a39.16,39.16,0,0,1-9,0,39.16,39.16,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,262.57a39.16,39.16,0,0,1-9,0,39.16,39.16,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,264.91a39.16,39.16,0,0,1-9,0,39.16,39.16,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,267.26a12.39,12.39,0,0,1-5.05,0,12.39,12.39,0,0,1,5.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.67,279.51v.8h-.87v-.77A3.88,3.88,0,0,1,274,279l.47-1.06a3.18,3.18,0,0,0,1.67.5c.59,0,.82-.16.82-.41,0-.8-2.87-.21-2.87-2.09,0-.79.57-1.47,1.74-1.61v-.79h.87v.78a3.41,3.41,0,0,1,1.46.42l-.44,1.06a3,3,0,0,0-1.4-.39c-.6,0-.81.2-.81.46,0,.77,2.86.19,2.86,2.05C278.34,278.68,277.79,279.34,276.67,279.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,238.81a30.63,30.63,0,0,1,.26,5.59,30.79,30.79,0,0,1-.26,5.6,29.75,29.75,0,0,1-.26-5.6A29.59,29.59,0,0,1,275.81,238.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.61,
    y: 255.03,
    width: 5.39,
    height: 1.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.03 397.46 324.63 433.8 327.11 433.8 310.87 397.46 303.03 397.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.49,
    y: 354.64,
    width: 13.16,
    height: 33.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.49,
    y: 375.18,
    width: 13.16,
    height: 13.13,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,388.31a6.56,6.56,0,0,1,0-.68c0-.47,0-1.1,0-1.9,0-1.69,0-4.06-.07-7,0-6-.07-14.38-.12-24.06l.25.25H308.49l.26-.26h0v9.64c0,3.12,0,6.12,0,9,0,5.7,0,10.8-.06,15.05l-.18-.18,9.59.09,2.63,0,.69,0a.77.77,0,0,1,.25,0s-.29,0-.87,0l-2.59.05-9.7.1h-.18v-.18c0-4.25,0-9.35-.06-15.05,0-2.85,0-5.85,0-9,0-1.55,0-3.14,0-4.75v-4.89h0l.26-.26H321.9v.25c0,9.75-.09,18.18-.12,24.23,0,2.94,0,5.3-.07,7,0,.78,0,1.39,0,1.85A4.52,4.52,0,0,1,321.65,388.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,364.87a39.16,39.16,0,0,1-9,0,37.72,37.72,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,367.21a39.16,39.16,0,0,1-9,0,39.16,39.16,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,369.55a39.16,39.16,0,0,1-9,0,39.16,39.16,0,0,1,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,371.89a12.39,12.39,0,0,1-5.05,0,12.39,12.39,0,0,1,5.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.87,384.15v.8H315v-.77a3.88,3.88,0,0,1-1.83-.55l.47-1.06a3.18,3.18,0,0,0,1.67.5c.59,0,.82-.16.82-.41,0-.8-2.87-.22-2.87-2.09,0-.8.57-1.47,1.74-1.61v-.8h.87v.78a3.56,3.56,0,0,1,1.46.43l-.44,1.06a3,3,0,0,0-1.4-.39c-.6,0-.81.2-.81.46,0,.77,2.86.19,2.86,2.05C317.54,383.32,317,384,315.87,384.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,343.45a60.33,60.33,0,0,1,0,11.19,60.33,60.33,0,0,1,0-11.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.81,
    y: 359.67,
    width: 5.39,
    height: 1.86,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.24 326.93 69.82 326.93 41.46 326.93 41.46 140.29 101.24 140.29 101.24 326.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,326.93s0-.32,0-.93,0-1.53,0-2.72c0-2.39,0-5.91,0-10.47,0-9.13,0-22.4-.07-39,0-33.22-.07-79.85-.12-133.49l.25.25H41.46l.26-.26c0,75.06-.07,142.26-.09,186.64l-.17-.17,43.95.08,11.75.05,3,0,1,0-1,0-3,0-11.74,0-44,.09h-.17v-.17c0-44.38-.06-111.58-.09-186.64V140h60.29v.25c0,53.71-.08,100.4-.11,133.67,0,16.6-.06,29.85-.07,39,0,4.54,0,8,0,10.42,0,1.18,0,2.08,0,2.69S101.24,326.93,101.24,326.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.82,
    y: 326.93,
    width: 3.77,
    height: 17.93,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.17 433.56 68.01 341.96 71.35 341.96 29.88 433.56 28.17 433.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.89 433.56 75.05 341.96 71.71 341.96 113.18 433.56 114.89 433.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.82 339.19 69.82 433.56 71.71 433.56 73.59 338.12 69.82 339.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "101.6 323.55 71.35 229.69 41.82 327.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.82,327.47s0-.17.12-.5l.42-1.47L44,319.89c1.46-4.89,3.55-11.93,6.14-20.62,5.24-17.41,12.47-41.43,20.45-68,.17-.58.35-1.16.51-1.7l.24-.8.26.8c8.35,26,15.88,49.47,21.34,66.46,2.69,8.48,4.87,15.33,6.39,20.1.73,2.35,1.31,4.19,1.71,5.46.18.61.33,1.09.43,1.43s.13.49.13.49-.07-.16-.18-.48l-.48-1.41c-.42-1.26-1-3.09-1.8-5.43-1.56-4.75-3.79-11.59-6.55-20.05L71.1,229.77h.5l-.51,1.7-20.6,67.92c-2.65,8.67-4.8,15.69-6.3,20.57-.74,2.41-1.33,4.28-1.73,5.58-.2.62-.36,1.1-.47,1.45S41.82,327.47,41.82,327.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,140.29a4.33,4.33,0,0,1-.13.47c-.1.33-.24.78-.43,1.36-.39,1.22-1,3-1.69,5.23-1.5,4.55-3.66,11.1-6.33,19.18L71.6,229.77c-1,0-.28,0-.51,0v0l0-.07,0-.14-.1-.29-.19-.58-.39-1.15c-.25-.77-.51-1.53-.76-2.3l-1.52-4.54c-1-3-2-6-3-8.88L59.49,195c-3.56-10.7-6.76-20.34-9.45-28.44s-4.83-14.63-6.33-19.18c-.73-2.25-1.3-4-1.69-5.23-.19-.58-.33-1-.43-1.36a4.33,4.33,0,0,1-.13-.47s.07.15.18.45.27.77.48,1.35c.41,1.21,1,2.95,1.78,5.19,1.54,4.54,3.75,11.07,6.49,19.13l9.55,28.4c1.79,5.35,3.68,11,5.63,16.78l3,8.88L70.06,225c.25.76.51,1.52.77,2.29l.38,1.15.19.58.1.29,0,.14,0,.08,0,0c-.22,0,.5,0-.49,0,8.28-24.66,15.78-47,21.21-63.18,2.73-8.07,5-14.6,6.49-19.14.77-2.23,1.37-4,1.78-5.19.21-.58.37-1,.48-1.35S101.24,140.29,101.24,140.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.14,
    y: 151.32,
    width: 13.16,
    height: 33.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.14,
    y: 171.86,
    width: 13.16,
    height: 13.13,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,185a6.33,6.33,0,0,1,0-.68c0-.47,0-1.1,0-1.9,0-1.68,0-4.06-.07-7,0-6-.07-14.37-.11-24.06l.25.25H80.14c.52-.52.14-.14.26-.25h0V161c0,3.11,0,6.11,0,9,0,5.69,0,10.79-.06,15l-.18-.18,9.59.1,2.63,0,.69,0,.25,0s-.29,0-.88,0l-2.58,0-9.7.1H80V185c0-4.25,0-9.35-.06-15,0-2.86,0-5.86,0-9v-9.64h0c.12-.12-.26.25.26-.27H93.55v.25c0,9.75-.09,18.19-.12,24.23,0,2.94-.05,5.3-.07,7,0,.77,0,1.38,0,1.84A4.52,4.52,0,0,1,93.3,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16,161.55a20,20,0,0,1-4.51.26,20,20,0,0,1-4.5-.26,19.31,19.31,0,0,1,4.5-.26A19.36,19.36,0,0,1,91.16,161.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16,163.89a20,20,0,0,1-4.51.26,20,20,0,0,1-4.5-.26,20,20,0,0,1,4.5-.26A20,20,0,0,1,91.16,163.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16,166.23a19.36,19.36,0,0,1-4.51.26,19.31,19.31,0,0,1-4.5-.26,20,20,0,0,1,4.5-.26A20,20,0,0,1,91.16,166.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,168.58a6.45,6.45,0,0,1-2.53.26,6.42,6.42,0,0,1-2.52-.26,6.2,6.2,0,0,1,2.52-.26A6.24,6.24,0,0,1,87.2,168.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.52,180.83v.8h-.87v-.77a3.88,3.88,0,0,1-1.83-.55l.47-1.05a3.24,3.24,0,0,0,1.67.5c.59,0,.82-.17.82-.42,0-.8-2.87-.21-2.87-2.09,0-.79.57-1.46,1.74-1.61v-.79h.87v.78a3.41,3.41,0,0,1,1.46.42l-.44,1.06a3,3,0,0,0-1.4-.39c-.6,0-.82.21-.82.46,0,.77,2.87.19,2.87,2.06C89.19,180,88.64,180.66,87.52,180.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.65,140.13a29.59,29.59,0,0,1,.26,5.59,29.75,29.75,0,0,1-.26,5.6,30.79,30.79,0,0,1-.26-5.6A30.63,30.63,0,0,1,86.65,140.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.46,
    y: 156.35,
    width: 5.39,
    height: 1.86,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.75,296.46l4-26.92-11.83-1s0,.26.06.65c.26,3.8-.7,26.15-.7,26.15-.55.88-2.75,4.84-3.08,6.7s-1.42,10,0,10.51a2.31,2.31,0,0,0,.82.16c-1.18.65-2.86,1.68-2.79,2.25a2.31,2.31,0,0,0,.88,1.42s7.11-1,8.53-1.75,4.38-6.35,4.06-7.34Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.63,302.79c.17,0-.17,2.43-.75,5.37-.15.7-.3,1.38-.44,2.06a5.31,5.31,0,0,1-.56,1.7,1.63,1.63,0,0,1-1,.74c-.3,0-.46,0-.45-.07a1.78,1.78,0,0,0,1.09-.89,6,6,0,0,0,.39-1.59c.13-.68.25-1.36.39-2.07A24.29,24.29,0,0,1,634.63,302.79Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.94,315.47c-.07-.07.36-.5.9-1.28a12.68,12.68,0,0,0,1.61-3.32,36.47,36.47,0,0,0,.9-3.64c.19-1,.34-1.54.43-1.53a4.13,4.13,0,0,1,0,1.59,17.4,17.4,0,0,1-.74,3.77,9.88,9.88,0,0,1-1.84,3.4C634.53,315.21,634,315.53,633.94,315.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.38,406.38l.28,26.67-35.1.46c.15-3.18,18.21-9.78,18.21-9.78l-.92-17.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.6,422.15a1.28,1.28,0,1,1-.58,2.5A1.43,1.43,0,0,1,614,423a1.46,1.46,0,0,1,1.78-.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.66,433.05l-.14-2.69-33.6,1.44s-1.56.67-1.36,1.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M604.2,423.57c0,.16.86.23,1.72.74s1.31,1.18,1.46,1.11-.11-1-1.15-1.59S604.16,423.42,604.2,423.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.54,425.06c0,.16.71.42,1.3,1.1s.77,1.4.95,1.39.26-.93-.49-1.76S600.54,424.9,600.54,425.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.51,429.25c.16,0,.39-.78-.07-1.66s-1.26-1.22-1.33-1.09.43.61.79,1.33S598.34,429.24,598.51,429.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.44,419.66c.08.14.86-.09,1.83,0s1.73.33,1.82.19-.65-.71-1.79-.75S604.36,419.53,604.44,419.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.22,415.71a3.43,3.43,0,0,0,1.76,0,8.34,8.34,0,0,0,2.83-1.08,2,2,0,0,0,.52-.4.67.67,0,0,0,.07-.86,1,1,0,0,0-.76-.36,2.48,2.48,0,0,0-.66.1,6.51,6.51,0,0,0-1.08.36,6.21,6.21,0,0,0-1.61,1c-.8.72-1.07,1.33-1,1.36s.46-.46,1.28-1.06a7.75,7.75,0,0,1,1.56-.85,7.31,7.31,0,0,1,1-.31c.37-.1.69-.1.79.05s0,.09,0,.19a1.79,1.79,0,0,1-.38.29,7.75,7.75,0,0,1-.92.51,9.81,9.81,0,0,1-1.69.64A11.78,11.78,0,0,0,605.22,415.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.44,415.94c.07,0,.4-.56.44-1.61a5,5,0,0,0-.27-1.82,5,5,0,0,0-.46-1,1.44,1.44,0,0,0-1.13-.82.81.81,0,0,0-.73.47,2.36,2.36,0,0,0-.17.61,3.49,3.49,0,0,0,0,1.12,3.87,3.87,0,0,0,.78,1.71c.7.85,1.42,1,1.43,1s-.54-.39-1.08-1.21a3.66,3.66,0,0,1-.58-1.55,3.1,3.1,0,0,1,0-1c0-.36.18-.64.32-.61s.48.26.62.54a4.38,4.38,0,0,1,.45.89,5.64,5.64,0,0,1,.37,1.66C605.52,415.31,605.35,415.92,605.44,415.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594,399.24l7.73,25.52L568.15,435c-.74-3.09,14.75-14.48,14.75-14.48l-5.66-16.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.86,416a1.35,1.35,0,0,1,1.4,1.18,1.39,1.39,0,0,1-1.26,1.38,1.29,1.29,0,1,1,0-2.56",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.72,424.76l-.89-2.54L569,433s-1.3,1.07-.82,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.31,420.55c.05.15.89,0,1.85.22s1.59.77,1.72.66-.38-.92-1.55-1.21S582.23,420.41,582.31,420.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.21,423c0,.16.8.2,1.56.69s1.13,1.13,1.29,1.07,0-1-1-1.55S579.17,422.85,579.21,423Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.44,427.59c.16,0,.15-.86-.54-1.58s-1.55-.82-1.58-.67.59.46,1.14,1.06S578.27,427.62,578.44,427.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.45,416.72c.11.12.8-.32,1.74-.55s1.75-.17,1.8-.33-.82-.49-1.93-.22S581.33,416.62,581.45,416.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09,412.71a3.33,3.33,0,0,0,1.68-.52,8.38,8.38,0,0,0,1.6-1.05,7.39,7.39,0,0,0,.81-.78,2.28,2.28,0,0,0,.4-.52.68.68,0,0,0-.18-.85,1,1,0,0,0-.83-.13,2,2,0,0,0-.6.27,6.14,6.14,0,0,0-1,.66,6.32,6.32,0,0,0-1.25,1.43c-.57.92-.66,1.58-.59,1.59s.32-.57.94-1.37a6.59,6.59,0,0,1,2.13-1.83c.33-.2.63-.3.77-.17s.06.06,0,.18a1.77,1.77,0,0,1-.29.39,10.51,10.51,0,0,1-.74.75,10.15,10.15,0,0,1-1.45,1.09A12.38,12.38,0,0,0,581.09,412.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.37,412.87a2.5,2.5,0,0,0,0-1.67,5.24,5.24,0,0,0-.77-1.67,5.48,5.48,0,0,0-.72-.83,1.43,1.43,0,0,0-1.32-.47.8.8,0,0,0-.57.65,2.25,2.25,0,0,0,0,.64,3.35,3.35,0,0,0,.33,1.07,3.77,3.77,0,0,0,1.22,1.42,2.33,2.33,0,0,0,1.65.54c0-.1-.63-.22-1.38-.86a3.79,3.79,0,0,1-1-1.33,3.37,3.37,0,0,1-.25-.92c0-.36,0-.67.14-.68a1,1,0,0,1,.75.35,5.12,5.12,0,0,1,.68.73,5.84,5.84,0,0,1,.82,1.48C581.27,412.24,581.27,412.87,581.37,412.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.19,297s-1.63,33.27-2,42.88c-.36,8.36-.25,16.41-.19,19.64a16.73,16.73,0,0,0,.67,3.17l15.08,54.72,19-4.11s-3.86-34.4-5-40.2-3-16.21-3-16.21l5.39-54.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,294.74c0,1.91,10.52,70.81,10.18,71.83s2.38,54.64,2.38,54.64h19.76s3.54-29.16,2.52-45.45,1-48.56,1.26-60.1,0-24.44,0-24.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,268.9a11.64,11.64,0,0,0-5-.46c-2.4.41-5.91,2.76-7.43,2.19s-1.56,1.38.14,2.3c1.09.6,5.13.67,5.13.67s-1.29,2.74-3.39,3.54-8,4.82-7.72,6,1.73.16,2.55-.16c.63-.24,5.24-2.33,5.24-2.33s-5.95,6.8-6.34,8,1.23,1,1.61.54c.23-.27.23,1.25,1.72,1.05,1-.14,4-2.5,4.64-3.28l1.35-1.61L515,290.67s.08,1.49,1.46.64c.62-.38,15-13.61,16-14.72,1.76-1.91,4.17-4.72,4.17-4.72L528.32,265Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.51,280.64a4.86,4.86,0,0,0-.69.65c-.42.43-1,1.08-1.76,1.89s-1.58,1.8-2.48,2.94a15.48,15.48,0,0,0-1.3,1.88,2.43,2.43,0,0,0-.24.61.74.74,0,0,0,0,.21l0,.16a2.44,2.44,0,0,0,.11.32.86.86,0,0,0,.6.46,1.09,1.09,0,0,0,.7-.12,7.24,7.24,0,0,0,1.06-.71l.95-.74c.61-.49,1.2-1,1.74-1.45,1.09-.95,2-1.86,2.79-2.64s1.35-1.45,1.74-1.92a4,4,0,0,0,.57-.76,5.14,5.14,0,0,0-.68.66c-.42.44-1,1.07-1.82,1.83s-1.73,1.64-2.82,2.57c-.55.47-1.13.95-1.75,1.43-.31.24-.62.48-.95.72a6.65,6.65,0,0,1-1,.68.87.87,0,0,1-.49.09.46.46,0,0,1-.33-.27,1.45,1.45,0,0,1-.09-.25l0-.13v-.09a2.2,2.2,0,0,1,.2-.49,16.62,16.62,0,0,1,1.25-1.85c.87-1.14,1.71-2.13,2.41-3l1.67-2A5,5,0,0,0,515.51,280.64Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.16,276.35c0,.06-.53.12-1.27-.28a4,4,0,0,1-1.93-2.49v0l.25.21a18.14,18.14,0,0,1-4.29-.26,17.58,17.58,0,0,1,4.3-.26h.19l.06.2v0a4.16,4.16,0,0,0,1.62,2.29C523.69,276.19,524.18,276.26,524.16,276.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.36,197.26s-7.72,2.78-12.7,12.41-10.45,27-12.4,29.88-17.34,17.28-22.93,28.24l8.31,6.95s28.78-21,30.94-25.54,6.84-15.67,6.84-15.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.19,297s13.23,7,27.52,6.3,34.79-3.62,34.79-3.62l.06-90.65,1.07-13.43-13.19-6.27-5.81-5.4-19.89,3.42L587.13,192l-12.77,5.25-3.82,28.54,1.73,20.71-1.73,24.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.93,195.23s7.86,4.37,10.24,8.17,7.36,38.07,7.36,38.07,2.6,15.67,2.38,21.72S646.8,295,646.8,295l-13-1.53-.18-31.65-7-32.41s-2-15.72-1.73-16.39S628.93,195.23,628.93,195.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.57,188.55l9.22,7L611,184.65l2.44,5.3s-4.7,4.64-4.41,4.3-9.15.32-11.14,2.36l-8.27-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.35,213a6.4,6.4,0,0,1,.35,1.29c.17.84.4,2.06.64,3.57.5,3,1.07,7.21,1.61,11.84s.93,8.84,1.14,11.9c.11,1.52.18,2.76.21,3.61a5.89,5.89,0,0,1,0,1.34,6.22,6.22,0,0,1-.21-1.32c-.11-1-.24-2.18-.4-3.6-.35-3.17-.81-7.3-1.32-11.86s-1-8.67-1.43-11.85c-.17-1.41-.33-2.61-.45-3.59A5.72,5.72,0,0,1,568.35,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.36,256.52c.06.16-4.8,2-10.84,4.18s-11,3.76-11.06,3.6a113,113,0,0,1,10.85-4.17C600.36,258,605.31,256.36,605.36,256.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.36,249.93a12.59,12.59,0,0,1-2.81.85c-1.77.42-4.23.92-7,1.3s-5.25.58-7.06.66a12.61,12.61,0,0,1-2.94-.05,16.24,16.24,0,0,1,2.91-.39c1.8-.18,4.28-.45,7-.83s5.18-.8,7-1.12A16.91,16.91,0,0,1,605.36,249.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.52,250.56c-.17,0-.19-12.23,0-27.31s.41-27.31.58-27.31.18,12.23,0,27.32S599.69,250.57,599.52,250.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.79,195.74a14.43,14.43,0,0,1-2.76-1.11c-.41-.17-.9-.43-1.34-.58s-.71.08-.8.69c-.22,1.21-.45,2.51-.69,3.87l-.09.48-.09.52-.41-.34a37.08,37.08,0,0,1-4.84-4.87,10.28,10.28,0,0,1-1.62-2.3,18.14,18.14,0,0,1,1.94,2A54.2,54.2,0,0,0,594,198.8l-.5.18q0-.22.09-.48c.26-1.36.5-2.66.73-3.87a1.57,1.57,0,0,1,.47-.94,1.05,1.05,0,0,1,1-.13c.56.23.95.48,1.38.68A14.8,14.8,0,0,1,599.79,195.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.23,189a16.55,16.55,0,0,1-2.52,2.49c-1.62,1.47-4,3.38-6.48,5.56l-1.5,1.32-.27.24-.18-.29a21.36,21.36,0,0,1-2.21-5.25l.36.12c-1.1.76-2,1.48-2.6,1.92a3.81,3.81,0,0,1-1,.62s.3-.32.87-.83,1.39-1.26,2.5-2.1l.25-.18.11.31a24,24,0,0,0,2.26,5.05l-.46-.05,1.5-1.35c2.53-2.19,4.92-4,6.61-5.42A25.2,25.2,0,0,1,616.23,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.61,213a14.06,14.06,0,0,1,.08,2.1c0,1.45,0,3.38,0,5.72,0,4.92.09,11.54.15,18.86s.16,13.94.22,18.86c0,2.34.07,4.27.09,5.72a14.36,14.36,0,0,1,0,2.1,15.3,15.3,0,0,1-.21-2.09c-.09-1.35-.19-3.3-.28-5.72-.18-4.82-.33-11.49-.4-18.86s0-14,0-18.87c0-2.42.09-4.37.15-5.72A13.8,13.8,0,0,1,628.61,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.38,259.61a27.56,27.56,0,0,1,0-8.11c.17,0,.31,1.81.31,4.05S597.55,259.61,597.38,259.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.47,303.32a10,10,0,0,1-.09-1.73c0-1.11,0-2.72.06-4.71.14-4,.63-9.45,1.3-15.47S598,269.94,598.21,266c.13-2,.22-3.58.26-4.69a9.55,9.55,0,0,1,.14-1.72,8.14,8.14,0,0,1,.1,1.73c0,1.11,0,2.72-.07,4.7-.14,4-.62,9.46-1.29,15.48s-1.23,11.47-1.48,15.43c-.12,2-.21,3.58-.26,4.69A9.7,9.7,0,0,1,595.47,303.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.86,245.93a26.61,26.61,0,0,1-2.86-2.47c-1.57-1.34-3-2.26-2.9-2.42a7.91,7.91,0,0,1,3.29,2C556,244.38,557,245.83,556.86,245.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M581.38,253.22c5.38,2.46,11.62,2.5,17.41,1.24s11.21-3.73,16.6-6.19C604.07,250.19,604.55,251,581.38,253.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587.5,192.48a19.72,19.72,0,0,0,6.52,8.94c.24.18.6.36.81.14a.73.73,0,0,0,.13-.39c.2-2.09.41-4.18.61-6.28a18.48,18.48,0,0,0,4.47.9s-3.91-2-4.54-1.95-.84.24-.9.91-.83,4.64-.83,4.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600,195.79c.49,0,.83-.32,1.27-.54a1.31,1.31,0,0,1,1.4,0,1.51,1.51,0,0,1,.4.76c.52,1.71,1,3.43,1.55,5.15,3.23-3.18,8-7.63,10.66-11.29l-9.79,8.33L603.3,193Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M571.32,236.52a31.07,31.07,0,0,1-2.62-24.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M574.8,160c1.32-1.67,3-3.27,3.29-5.38.31-1.93-.53-4,.33-5.8,1.07-2.16,4.14-2.58,5.46-4.59.65-1,.8-2.21,1.44-3.18,1.08-1.67,3.3-2.21,5.29-2.09s3.92.73,5.9.77c2.73.06,5.49-1,8.14-.31,2.92.72,4.8,3.18,6.8,5.55l2.58,2.74a10.19,10.19,0,0,0,1.69,1.24,19.86,19.86,0,0,1,3.18,1.82,4.82,4.82,0,0,1,0,6.95,5.14,5.14,0,0,1,3.71,4.87,14.54,14.54,0,0,1-.76,3.54,5.15,5.15,0,0,0,.08,3.55,2.27,2.27,0,0,0,3,1.13,5.44,5.44,0,0,1-2.78,3.75,3.28,3.28,0,0,0,2.23.86c-2,5.28-7.82,8.29-13.45,8.59s-11.11-1.58-16.43-3.43l-15.33-3.22c-1.35-.24-2-1.83-2-3.19s.23-2.81-.32-4.06c-.75-1.71-2.82-2.54-3.6-4.25C572.37,164,573.47,161.7,574.8,160Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.29,172.15a63.66,63.66,0,0,0,2.18-10.56A21.81,21.81,0,0,0,612.06,151c-.21-.5-2-3.84-2.55-3.76-.38.06.78,3.2.6,3.55a18.52,18.52,0,0,0-1.52,10.88,48.78,48.78,0,0,0,2.7,10.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.94,158.42c-.17-9-5.57-16.44-14.58-16l-.83.09a16.12,16.12,0,0,0-14.44,16.43c.19,7.82.5,16.46,1,20.61,1,8.61,9.77,9,9.77,9s.17,3.12.17,3.12l8.84,7.71,10.25-9.92Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.85,188.57a21,21,0,0,0,10.86-4.5s-2.19,6.88-10.86,7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.92,165.6a1.24,1.24,0,0,0,1.32,1.11,1.18,1.18,0,0,0,1.15-1.24,1.25,1.25,0,0,0-1.32-1.12A1.19,1.19,0,0,0,583.92,165.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.3,162.3c.17.15,1-.64,2.36-.78s2.36.43,2.48.25-.12-.35-.57-.62a3.43,3.43,0,0,0-2-.39,3.29,3.29,0,0,0-1.85.82C583.33,161.93,583.22,162.24,583.3,162.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.71,165.6a1.22,1.22,0,0,0,1.32,1.11,1.18,1.18,0,0,0,1.15-1.24,1.25,1.25,0,0,0-1.32-1.12A1.19,1.19,0,0,0,595.71,165.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.32,161.47c.17.15,1-.64,2.36-.78s2.36.43,2.48.25-.12-.35-.57-.62a3.43,3.43,0,0,0-2-.39,3.29,3.29,0,0,0-1.85.82C596.35,161.1,596.24,161.41,596.32,161.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.65,172.14a9.22,9.22,0,0,0-2.19-.16c-.34,0-.67,0-.75-.26a1.62,1.62,0,0,1,.12-1l.72-2.68a44.2,44.2,0,0,0,1.54-7,45.05,45.05,0,0,0-2.09,6.83l-.69,2.69a2,2,0,0,0,0,1.34.85.85,0,0,0,.61.44,2.33,2.33,0,0,0,.58,0A8.38,8.38,0,0,0,592.65,172.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.64,172.65c-.22,0-.07,1.44-1.19,2.59s-2.67,1.15-2.66,1.36.37.24,1,.19a3.65,3.65,0,0,0,2.23-1,3.15,3.15,0,0,0,.9-2.17C596.93,173,596.74,172.63,596.64,172.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.83,156.09c.17.35,1.47,0,3,.06s2.88.32,3,0c.07-.16-.18-.48-.72-.77a5.21,5.21,0,0,0-2.32-.55,5.1,5.1,0,0,0-2.32.53C596,155.62,595.76,155.93,595.83,156.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.39,157.85c.26.27,1.14-.14,2.23-.27s2,0,2.23-.34c.08-.17-.1-.45-.54-.69a3,3,0,0,0-1.87-.3,3.07,3.07,0,0,0-1.72.79C583.36,157.39,583.27,157.71,583.39,157.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.91,164.87c.14-.08,5.73-2.37,6.16,3.53s-6.14,5.26-6.16,5.09S610.91,164.87,610.91,164.87Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.1,171s.11.06.29.13a1,1,0,0,0,.77,0,2.54,2.54,0,0,0,1-2.37,3.22,3.22,0,0,0-.4-1.45,1.21,1.21,0,0,0-.83-.74.52.52,0,0,0-.58.33c-.07.17,0,.29-.06.3s-.13-.09-.1-.34a.66.66,0,0,1,.21-.39.77.77,0,0,1,.55-.19,1.48,1.48,0,0,1,1.15.84,3.53,3.53,0,0,1,.47,1.62,2.69,2.69,0,0,1-1.31,2.66,1.08,1.08,0,0,1-.95-.09C613.12,171.13,613.08,171,613.1,171Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.28,148.89c-1-.47,1.68-3.75,4-5,3.45-1.84,8.81-3.18,12.15-2.47,4,.87,7.42,2.62,9.63,6.08a23.32,23.32,0,0,1,3.37,11.7,7,7,0,0,1-.6,3.67c-.74,1.36-2.27,2.28-2.08,4.08a2.53,2.53,0,0,1-.5,1.85c-1,1.22-2.4.22-3.08-.82-1.45-2.24-1.77-5-2.06-7.63a17.27,17.27,0,0,1,0-5.65c.22-1,.63-2,.8-3a3,3,0,0,0-1.12-3.38,6.17,6.17,0,0,0-6.19-.77c-3.26,1.39-8.83,3.52-10.39,2.48a8.9,8.9,0,0,1-2.81-2.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,140.67a13,13,0,0,0-9.95,1.19,6.76,6.76,0,0,0-3.31,4.16,3.87,3.87,0,0,0,2.23,4.46l.12.07c2.58.68,4.2.24,6.65-.79,2.07-.87,3.87-2.3,5.94-3.16a12.05,12.05,0,0,1,7-.65A19.66,19.66,0,0,0,600,140.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.16,178.47s-.21,0-.6,0a3.07,3.07,0,0,1-1.58-.56,3.77,3.77,0,0,1-1.5-2.15,7.12,7.12,0,0,1,.07-3.54c.29-1.3.86-2.67,1.18-4.25a7.47,7.47,0,0,0,.13-2.51,4.7,4.7,0,0,0-1-2.48,5.53,5.53,0,0,0-2.37-1.5,14.85,14.85,0,0,1-2.59-1.11,8.41,8.41,0,0,1-3.26-4.72c-.65-1.93-.9-3.93-1.43-5.82a10.62,10.62,0,0,0-2.64-5,7.06,7.06,0,0,0-4.72-1.87,9.17,9.17,0,0,0-4.35,1,13.69,13.69,0,0,0-4.79,4.22c-.45.62-.76,1.11-1,1.46a2.26,2.26,0,0,0-.28.53,3.41,3.41,0,0,0,.35-.49c.23-.32.57-.8,1-1.39a14,14,0,0,1,4.79-4.06,9,9,0,0,1,4.2-.88,6.75,6.75,0,0,1,4.47,1.81,10.19,10.19,0,0,1,2.5,4.81c.52,1.85.77,3.86,1.43,5.85a8.73,8.73,0,0,0,3.46,4.94,15.39,15.39,0,0,0,2.65,1.13,5.31,5.31,0,0,1,2.22,1.38,4.4,4.4,0,0,1,1,2.27,7.33,7.33,0,0,1-.1,2.39c-.31,1.53-.86,2.92-1.14,4.26a7.3,7.3,0,0,0,0,3.66,3.94,3.94,0,0,0,1.64,2.23,3,3,0,0,0,1.67.51A1.73,1.73,0,0,0,622.16,178.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.81,140.61a3.56,3.56,0,0,0-1.79.27,6.85,6.85,0,0,0-4.67,6.84,3.69,3.69,0,0,0,.4,1.77c.07,0-.12-.68-.1-1.77a7.14,7.14,0,0,1,4.47-6.56C593.13,140.75,593.82,140.68,593.81,140.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.9,146.54a3.07,3.07,0,0,0-.44,2.15,3.15,3.15,0,0,0,.7,2.09c.12-.05-.21-.95-.28-2.11S582,146.57,581.9,146.54Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.63,201.79c-.23-.6-.91-.88-1.48-1.18a6.35,6.35,0,0,1,.11-11.28,4.91,4.91,0,0,0,1.46-.88c1-1,.36-2.72.57-4.13.46-3,4.44-4.13,5.51-6.95.65-1.72.06-3.62-.29-5.42s-.32-4,1.12-5.11c.78-.62,1.83-.8,2.58-1.45,1.55-1.32,1.11-3.76,1.46-5.77a7,7,0,0,1,6.84-5.59s-1.65-2.55,1.44-4.43c3.73-2.28,4.41.54,6-1.51a6.07,6.07,0,0,1,7.4-1.63,16.94,16.94,0,0,0,2.24,1.24,11.83,11.83,0,0,0,3.1.32c4,.28,11.17,4,9.68,9.31l-20.42,47.43a45.81,45.81,0,0,0-8.16,4c-.76.49-1,7.09-1.87,7.37a5.65,5.65,0,0,1-3.33-.05,9.5,9.5,0,0,1-5.67-4.39,6.1,6.1,0,0,1-8.77-7.81C500.43,203.18,500.88,202.47,500.63,201.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.93,164.13l.24-3-18.11-4.59c-5.62-.94-12.07,4.36-12.77,10-.77,6.27-1.47,14-1,18.71.93,9.54,8.1,11.18,8.1,11.18l-.52,9.39,20.89,1.52Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.56,174.86a1.2,1.2,0,0,0,1.09,1.29,1.17,1.17,0,0,0,1.32-1,1.21,1.21,0,0,0-1.1-1.29A1.16,1.16,0,0,0,521.56,174.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.05,170.63c.14.17,1.1-.45,2.4-.37s2.22.79,2.38.64-.07-.36-.47-.69a3.32,3.32,0,0,0-1.88-.71,3.18,3.18,0,0,0-1.93.5C521.13,170.28,521,170.56,521.05,170.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.18,175.5a1.21,1.21,0,0,0,1.1,1.29,1.16,1.16,0,0,0,1.31-1,1.22,1.22,0,0,0-1.09-1.29A1.16,1.16,0,0,0,533.18,175.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.86,171.65c.14.16,1.1-.46,2.4-.38s2.22.79,2.37.64-.06-.36-.46-.69a3.39,3.39,0,0,0-1.88-.71,3.25,3.25,0,0,0-1.93.5C533.94,171.29,533.79,171.57,533.86,171.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.54,181a7.91,7.91,0,0,0-2.09-.51c-.34-.06-.65-.14-.69-.37a1.78,1.78,0,0,1,.28-1l1.14-2.47a42.86,42.86,0,0,0,2.61-6.51,44.93,44.93,0,0,0-3.13,6.28c-.38.87-.75,1.7-1.09,2.49a2,2,0,0,0-.26,1.3.84.84,0,0,0,.52.52,2.2,2.2,0,0,0,.56.11A9.11,9.11,0,0,0,528.54,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.39,196.42a25.05,25.05,0,0,0,13.18-2.62s-3.59,6.43-13.32,5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.52,183.28c.53.21.4.6.72,1.08a1.35,1.35,0,0,1,0,1.56,2.86,2.86,0,0,1-2,.91c-1.09-.06-1.27-.84-1.55-1.57l-.29-.91C529.3,184.06,531.11,183.11,531.52,183.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.83,166.51c.11.37,1.42.28,2.94.55s2.73.77,3,.47c.1-.15-.09-.5-.57-.87a5.23,5.23,0,0,0-4.49-.77C534.08,166.08,533.78,166.34,533.83,166.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.76,166.89c.21.31,1.12.05,2.21.1s2,.32,2.21,0,0-.46-.41-.76a3.21,3.21,0,0,0-3.56-.1C521.81,166.44,521.66,166.74,521.76,166.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.33,159.7A15.88,15.88,0,0,1,528,154l15.3,1.93,4.18,2.51a2.8,2.8,0,0,0-.49-2.06c1.44-1.1,6.35-2.87,9.83.76,1.25,1.3,2.3,4.79,2.32,6.6,0,.69-.05,1.52.52,1.9a2,2,0,0,0,.68.22,7.91,7.91,0,0,1,5.8,9.07,1.89,1.89,0,0,0-.08.78,2,2,0,0,0,.68,1,6.76,6.76,0,0,1,1.07,7.52,7.84,7.84,0,0,0-1,2.26c-.24,1.47.84,2.78,1.67,4,2.5,3.7,3,9.09.1,12.46a7.1,7.1,0,0,0-1.89,2.61,6.51,6.51,0,0,0-.09,1.59c0,2.69-1.4,5.7-4,6.27-1.46.32-3.24-.1-4.28,1a6.52,6.52,0,0,0-.93,1.7,5.46,5.46,0,0,1-6.29,2.71c-2.38-.73-3.17-10.36-2.82-12.83-2.88-1-5-1.23-4.87-4.28,0,0,.44-5.27-.41-7.83s.86-8,1.83-10.67-.19-8.81-.45-11.27a9,9,0,0,1,.21-2.09h0c.1-.6.24-1.27.41-2a18.85,18.85,0,0,0,.05-2,3.48,3.48,0,0,0-4.56-3.24,5.45,5.45,0,0,1-1.65.29,5.85,5.85,0,0,1-4.73-2.24,8.43,8.43,0,0,1-8.34,2.28,23.26,23.26,0,0,1-3.95,4.61,7.75,7.75,0,0,1-5.61,1.92A15.88,15.88,0,0,1,519.33,159.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.92,162.44s0-.35,0-1a6.12,6.12,0,0,1,.79-2.5,5.63,5.63,0,0,1,2.93-2.52,5.89,5.89,0,0,1,4.75.3l.12.06.08-.1a8.76,8.76,0,0,1,2.08-1.83,8.9,8.9,0,0,1,5.69-1.29,8.78,8.78,0,0,1,4.41,1.91,9.31,9.31,0,0,1,2.13,2.49c.39.67.54,1.09.57,1.07a2,2,0,0,0-.1-.3,6.48,6.48,0,0,0-.36-.83,8.9,8.9,0,0,0-2.1-2.6,8.73,8.73,0,0,0-4.52-2,9,9,0,0,0-8,3.21l.19,0a6.16,6.16,0,0,0-5-.28,5.9,5.9,0,0,0-3.72,5.26,3.83,3.83,0,0,0,0,.72A.79.79,0,0,0,520.92,162.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.6,186.56a4.08,4.08,0,0,0,1.3,0,1.75,1.75,0,0,0,1.09-.74,1.62,1.62,0,0,0,0-1.56,6.13,6.13,0,0,0-.56-1l.2.06a19.88,19.88,0,0,1-3.34.94,19.6,19.6,0,0,1,3.23-1.26l.12-.05.08.11a7.16,7.16,0,0,1,.6,1,1.88,1.88,0,0,1-.08,1.88,1.92,1.92,0,0,1-1.31.81A1.7,1.7,0,0,1,529.6,186.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.83,162.32c-.06,0-.34-.6-1.07-1.38a6.49,6.49,0,0,0-7.59-1.49c-1,.44-1.46.91-1.51.86A1.42,1.42,0,0,1,546,160a5.32,5.32,0,0,1,1.08-.74,6.35,6.35,0,0,1,7.89,1.56,5.72,5.72,0,0,1,.72,1.09A1.12,1.12,0,0,1,555.83,162.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.24,190.6a3.68,3.68,0,0,1-1.21-.8,5.74,5.74,0,0,1-1.71-3.54,5.55,5.55,0,0,1,.38-2.73,5.65,5.65,0,0,1,.81-1.32,3.54,3.54,0,0,0,.78-1.31,1.63,1.63,0,0,0-.45-1.41c-.36-.42-.82-.78-1.25-1.22a3.13,3.13,0,0,1-.91-1.67,4.71,4.71,0,0,1,.09-1.94,30.23,30.23,0,0,1,1.43-3.43,6.84,6.84,0,0,0,.45-3.31,6.71,6.71,0,0,0-2.8-4.79,7.26,7.26,0,0,0-3.62-1.27c-.92-.06-1.43,0-1.43,0a1.52,1.52,0,0,1,.36-.08,6,6,0,0,1,1.08-.07,7,7,0,0,1,3.75,1.21,7.07,7.07,0,0,1,2.54,8.42,29.68,29.68,0,0,0-1.41,3.4,4.19,4.19,0,0,0-.09,1.79,2.81,2.81,0,0,0,.81,1.49c.4.42.87.78,1.26,1.24a2,2,0,0,1,.51,1.7,3.88,3.88,0,0,1-.85,1.44,5.19,5.19,0,0,0-.79,1.24,5.32,5.32,0,0,0-.39,2.59,5.68,5.68,0,0,0,1.55,3.46A11.53,11.53,0,0,0,555.24,190.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.12,182.67a9.79,9.79,0,0,0-2.37,10.86,12.56,12.56,0,0,0-3.36,3.57,5.88,5.88,0,0,0-.64,4.74,3.88,3.88,0,0,0,3.73,2.68,6.12,6.12,0,0,0,10.44-3.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.73 425.66 536.58 419.12 524.98 419.1 526.25 426.69 530.39 429.19 537.73 425.66",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,425.21V426s-12.65,5.22-12.76,7.63l25.22-.37-.47-8.39A14.43,14.43,0,0,1,526,425.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.48,427.55a1,1,0,0,1,.73,1.17,1,1,0,0,1-1.15.73,1.1,1.1,0,0,1-.77-1.24,1,1,0,0,1,1.28-.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.46,433.22l-.11-2-24.14,1.1s-1.11.5-1,1.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.92,426c0,.12.62.17,1.23.55s.94.9,1.06.85-.09-.76-.84-1.21S525.89,425.91,525.92,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.29,427.16c0,.12.51.32.93.84s.56,1.06.68,1.05.19-.7-.35-1.33S523.29,427,523.29,427.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.83,430.35c.11,0,.27-.59-.05-1.26s-.91-.93-1-.83.31.46.57,1S521.71,430.34,521.83,430.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.76 411.12 538.75 430.59 547.68 429.1 547.88 409.93 536.76 411.12",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.64,425.41s-5.9,5-9.32,1.49l-.63,1.91-2.35,13.4a1.74,1.74,0,0,0,3,1.48c2.37-2.65,11-12.48,10.84-13.68l-.35-3.2a1.64,1.64,0,0,0-1.21-1.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.87,444.27,549.1,428.9l.06.7a1.94,1.94,0,0,1-.5,1.61c-1,1.54-3.69,5.06-10.25,12.48a1.78,1.78,0,0,1-1.54.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.91,427a1,1,0,0,0-.17,1.37,1,1,0,0,0,1.39.16,1.06,1.06,0,0,0,.17-1.44,1.08,1.08,0,0,0-1.47,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M540.1,436.69a3.83,3.83,0,0,0-3.6-1.34s.19-.19.58-.28a2.74,2.74,0,0,1,1.54.13,2.69,2.69,0,0,1,1.24.91C540.09,436.43,540.14,436.67,540.1,436.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.09,439a14.64,14.64,0,0,0-1.57-.57,16.31,16.31,0,0,0-1.68-.06,2,2,0,0,1,1.75-.3C538.62,438.28,539.17,439,539.09,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.09,433.64a9.15,9.15,0,0,0-4.93-1.38,3.92,3.92,0,0,1,2.67,0A3.83,3.83,0,0,1,542.09,433.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,429.64c0,.1-1-.2-2.23-.13s-2.17.45-2.22.35a4.43,4.43,0,0,1,4.45-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.08,429.54a1.41,1.41,0,0,1,0-.62,4.34,4.34,0,0,1,.67-1.6,2,2,0,0,1,.94-.85.7.7,0,0,1,.77.22,1.09,1.09,0,0,1,.2.77,2.46,2.46,0,0,1-2.37,2,2.83,2.83,0,0,1-2.66-1.69.93.93,0,0,1,0-.81.7.7,0,0,1,.75-.29,2.44,2.44,0,0,1,1.06.66,5,5,0,0,1,1,1.39,1.49,1.49,0,0,1,.21.59,8.23,8.23,0,0,0-1.43-1.79,2.29,2.29,0,0,0-.94-.55.37.37,0,0,0-.41.16.65.65,0,0,0,0,.53,2.56,2.56,0,0,0,2.33,1.44,2.14,2.14,0,0,0,2-1.7.79.79,0,0,0-.11-.54.39.39,0,0,0-.43-.13,1.77,1.77,0,0,0-.8.71A6.33,6.33,0,0,0,539.08,429.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,269.84s-4,18.08-4.2,32.12,12.76,53.8,14.71,62.93c1.32,6.22,7,37.27,14.1,56l10.63-.39s-8.89-63.17-8.89-69.78,1-41.86,1-41.86l2.37-26.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.34,274.69c-.78.29-28.16,6.16-28.16,6.16s-6.48,72.73-6.89,82.28,15,57.41,15,57.41h14.65s-.63-30.67-2.85-40.44c-2.57-11.31-5-13.83-3.9-20s12.26-35.79,15.05-52.05S555.34,274.69,555.34,274.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.63,292s.2,0,.55.05a13.07,13.07,0,0,1,1.45.35,18.64,18.64,0,0,1,4.51,2,19.12,19.12,0,0,1,3.86,3.06,13.26,13.26,0,0,1,1,1.12,2.29,2.29,0,0,1,.31.46s-.56-.55-1.47-1.4a22.86,22.86,0,0,0-3.86-2.94,23.1,23.1,0,0,0-4.4-2C509.38,292.23,508.62,292.05,508.63,292Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.11,420.54l-.25,0h-.75l-2.9,0-11,0h-.08l0-.08c-1.74-5.9-4-13.53-6.46-22.31s-5.33-18.71-7.94-29.32c-.26-1.16-.54-2.3-.75-3.46a19.48,19.48,0,0,1-.3-3.48c0-2.31,0-4.58.06-6.81.09-4.45.24-8.75.38-12.84.29-8.19.62-15.56.9-21.74s.55-11.2.75-14.66c.11-1.71.2-3.05.25-4,0-.45.06-.8.09-1s.05-.35.05-.35c0,1-.35,7.83-.88,20-.26,6.18-.56,13.55-.83,21.74-.14,4.09-.28,8.39-.36,12.84,0,2.23-.08,4.5,0,6.79a17.92,17.92,0,0,0,.29,3.43c.21,1.14.48,2.29.75,3.43,2.6,10.6,5.44,20.53,7.9,29.32l6.36,22.34-.11-.08,11,.05,2.9,0h.75A1.15,1.15,0,0,1,550.11,420.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.66,292c0,.07-1.21,0-3.15.07a26.78,26.78,0,0,0-3.38.41,29.54,29.54,0,0,0-4,1.09,30.66,30.66,0,0,0-3.8,1.71,26.34,26.34,0,0,0-2.87,1.83c-1.57,1.14-2.43,2-2.48,1.94a3.85,3.85,0,0,1,.57-.63c.2-.19.44-.42.74-.67s.62-.56,1-.85a23.76,23.76,0,0,1,2.87-1.91,24.85,24.85,0,0,1,7.91-2.83,24.9,24.9,0,0,1,3.43-.35c.49,0,.93,0,1.32,0a9.1,9.1,0,0,1,1,.06A3.3,3.3,0,0,1,542.66,292Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,252.55s25.07-17.18,28.81-19.44c4.48-2.72,11.89-8,11.89-8l18.91-14.32a20.75,20.75,0,0,1,9-3.9l1.78-.3-1.87,21.8s-26.25,16.36-29.49,18.43c-3.85,2.46-32,16.3-32,16.3L443,252.55",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.1,207.54a21.07,21.07,0,0,0-7.82-3.56l-13.66-.24c-.26.13-6.6,2.56-6.6,2.56l-1.16,3.89-2.4,10.21,1.27,8s28.51-16.43,28.31-16.49S548.1,207.54,548.1,207.54Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.48,204.52s20.39,6.43,21,10.78S546,258.87,546,258.87s20.14,30.38,13,30.63c-6.1.22-62-3.76-62.45-6.36-.1-.6,3.31-24.53,5.27-40,.71-5.62.73-9.54,1-11.65,1.14-8,8.39-24.52,8.39-24.52L524,204.2a29,29,0,0,0-3.62,18S540.78,209.25,542.48,204.52Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510.84,255l-10.07,1.33q1.46,2.44,3.06,4.78c.86,1.27,1.87,2.6,3.34,3s3.15-.26,4.7-.67,3.51-.41,4.41.92c1.07,1.58-.06,4,1.16,5.48a4.19,4.19,0,0,0,2.41,1.14l18.87,4.36a23.57,23.57,0,0,0,7.94.91c2.65-.31,5.35-1.72,6.46-4.15Q531.66,264.35,510.84,255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M563.31,214.78s4.21,6.33,5,20c.44,7.79-1,20-2.49,29.68a11.58,11.58,0,0,1-11.69,10.24c-4.78-.11-26.91-4.12-33.55-6.2l1.59-6.76,2.79-9.22,19.21,1.09a2.08,2.08,0,0,1,.91-2.34c1.41-1.09,4.06-11.22,4.06-11.22Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.08,236.25s0,.11,0,.31-.05.53-.08.92c-.07.83-.18,2-.31,3.56s-.33,3.46-.54,5.69c-.11,1.12-.23,2.31-.38,3.58l-.07.48v.07s0,.12-.09.13l-.11,0-.23.08a1.66,1.66,0,0,0-.71.58,2.7,2.7,0,0,0-.29,1.93l0,.15h-.15l-18.87-1.2.15-.11c-.75,2.45-1.55,5-2.38,7.71-.2.68-.43,1.35-.62,2s-.37,1.39-.55,2.09c-.38,1.41-.76,2.84-1.15,4.28l-.05-.17,1.28.3,1.38.3,2.8.59,5.76,1.18c3.91.77,8,1.54,12.07,2.25,2.65.45,5.26.88,7.85,1.17a17.14,17.14,0,0,0,3.84.14,11.37,11.37,0,0,0,3.58-1.1,11.66,11.66,0,0,0,5.1-5.11,14.5,14.5,0,0,0,1.23-3.35c.3-1.14.53-2.3.74-3.44a127.63,127.63,0,0,0,1.56-13.08c.29-4.12.44-8,.38-11.49a58.72,58.72,0,0,0-2.56-16.37,33,33,0,0,0-1.64-4.21c-.22-.47-.41-.81-.53-1.05l-.19-.35s.08.11.22.34.33.57.57,1a33.35,33.35,0,0,1,1.71,4.2,58.22,58.22,0,0,1,2.67,16.41c.08,3.52-.06,7.38-.33,11.51a126,126,0,0,1-1.54,13.12c-.21,1.15-.44,2.31-.74,3.47a14.48,14.48,0,0,1-1.24,3.42,12.15,12.15,0,0,1-5.25,5.27,11.51,11.51,0,0,1-3.7,1.12,16.61,16.61,0,0,1-3.92-.13c-2.6-.29-5.22-.72-7.87-1.17-4.13-.71-8.16-1.48-12.08-2.26l-5.76-1.18-2.81-.6-1.37-.3-.69-.16-.35-.08-.39-.13-.09,0,0-.14,1.16-4.29c.18-.7.37-1.4.56-2.09s.42-1.36.62-2c.84-2.68,1.64-5.26,2.4-7.71l0-.11h.12l18.87,1.27-.12.14a2.88,2.88,0,0,1,.33-2.1,1.93,1.93,0,0,1,.81-.66l.25-.08.12,0s-.08.06-.06,0v-.05c0-.16,0-.32.07-.47.16-1.27.28-2.46.4-3.58.23-2.22.43-4.13.6-5.68s.28-2.73.37-3.55c0-.4.08-.7.1-.92S547.08,236.25,547.08,236.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.71,218.71a4.45,4.45,0,0,1-.25.56c-.18.35-.44.88-.74,1.57a40.42,40.42,0,0,0-2.12,6,61.33,61.33,0,0,0-1.61,9.34c-.19,1.78-.31,3.65-.43,5.6s-.41,4-.72,6c-.62,4.1-1.32,8-1.92,11.5s-1.13,6.71-1.52,9.39-.63,4.86-.77,6.37c-.06.73-.11,1.31-.15,1.73a3.73,3.73,0,0,1-.07.61,4.71,4.71,0,0,1,0-.61c0-.4,0-1,.08-1.74.1-1.52.3-3.7.66-6.39s.85-5.88,1.44-9.41,1.28-7.42,1.9-11.5c.31-2,.59-4,.72-6s.26-3.83.45-5.61a58.77,58.77,0,0,1,1.7-9.38,36.27,36.27,0,0,1,2.23-6c.32-.69.61-1.21.81-1.56A4.85,4.85,0,0,1,507.71,218.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.71 249.71 524.93 252.55 521.62 263.48 515.71 258.98 515.71 249.71",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,249.79a54.86,54.86,0,0,0-6.18-2.12,36.82,36.82,0,0,0-4.4.75,2.38,2.38,0,0,0-1.19.63l-2.14,2,3.14.08,1.09-.52,1.93-.36Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.45,249.28,505,252.05l-8.46,1.48a2,2,0,0,0,1.71,2c1,.15,3.33.31,3.33.31a2.81,2.81,0,0,0,2,1.61,4.35,4.35,0,0,0,1.45,1.29,1.12,1.12,0,0,0,.26.08c.83.12,2.7,2,3.8,2.18s6.67-2,6.67-2v-9.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.41,254.19s-.44.16-1.15.41a22.2,22.2,0,0,1-5.74,1.18c-.75.05-1.21.05-1.21.07s.11,0,.32,0,.52,0,.9,0a17.49,17.49,0,0,0,2.93-.35,19.73,19.73,0,0,0,2.84-.83c.35-.14.63-.26.82-.36A1.33,1.33,0,0,0,509.41,254.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.63,256.7a1.15,1.15,0,0,0,.14.55,1.2,1.2,0,0,0,.38.52,1,1,0,0,0,.78.14,1.86,1.86,0,0,0,.71-.32c.19-.13.35-.26.49-.37s.46-.31.45-.34a1.4,1.4,0,0,0-.51.25,3.57,3.57,0,0,1-1.17.62.89.89,0,0,1-.67-.1,1.23,1.23,0,0,1-.36-.44A4.49,4.49,0,0,0,508.63,256.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.48,257.85a2.41,2.41,0,0,0,.64.07,14.18,14.18,0,0,0,1.57,0c.62,0,1.17-.13,1.56-.2a2.56,2.56,0,0,0,.63-.16c0-.05-1,.11-2.2.2S504.48,257.8,504.48,257.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.15,259.62a2,2,0,0,0,2,0s-.45.11-1,.1S509.17,259.58,509.15,259.62Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.07,259.81a1.51,1.51,0,0,0,.64.07,1.43,1.43,0,0,0,.64-.08,1.43,1.43,0,0,0-.64-.08C507.36,259.73,507.07,259.76,507.07,259.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,252.05a15.9,15.9,0,0,0,2.55-1.27c.69-.39,1.31-.75,1.75-1a3.85,3.85,0,0,0,.68-.48,5.45,5.45,0,0,0-.74.39l-1.76,1-1.76,1A5.51,5.51,0,0,0,505,252.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.27,214.11a5.31,5.31,0,0,1-1,.13l-.56,0c-.21,0-.42.09-.66.13a11,11,0,0,0-1.57.4l-.89.3-.92.44-.49.24-.46.29a11.58,11.58,0,0,0-1,.64,15.24,15.24,0,0,0-3.53,3.73,21,21,0,0,0-1.35,2.31,24.8,24.8,0,0,0-2,6.41,28.48,28.48,0,0,0-.31,2.84,7.2,7.2,0,0,1-.11,1,7.36,7.36,0,0,1,0-1.06,22.05,22.05,0,0,1,.2-2.87,22.91,22.91,0,0,1,1-4.17,21.44,21.44,0,0,1,.94-2.36,19.6,19.6,0,0,1,1.37-2.35,15.19,15.19,0,0,1,3.63-3.8c.31-.25.67-.43,1-.64l.49-.29.5-.23,1-.43.92-.29a8.55,8.55,0,0,1,1.61-.35,6.06,6.06,0,0,1,.67-.1l.57,0A7,7,0,0,1,562.27,214.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.94,260.82a23.82,23.82,0,0,0-1.92-3.93,22.62,22.62,0,0,0-2.9-3.28,3.57,3.57,0,0,1,1.09.73,10.93,10.93,0,0,1,2.11,2.35,11.32,11.32,0,0,1,1.37,2.85A3.5,3.5,0,0,1,548.94,260.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.19,254a22.38,22.38,0,0,0-4.58-2.31,23.25,23.25,0,0,0-5.05-.9,4.72,4.72,0,0,1,1.53-.1,12.74,12.74,0,0,1,3.64.66A12.94,12.94,0,0,1,554,253,4.35,4.35,0,0,1,555.19,254Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M548.79,260.34a13.24,13.24,0,0,0-4.65-6.7l0,.07a14.7,14.7,0,0,1,3.19,8.1,2.57,2.57,0,0,0,.25,1.1.79.79,0,0,0,1,.38.92.92,0,0,0,.43-.61A4.26,4.26,0,0,0,548.79,260.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M418.39,271.16l9.48-8.53,16-8.84,5.49,8.16-6.49,4.47-1.26,1.74a1.4,1.4,0,0,1,1.26,1.89,7.36,7.36,0,0,1-2.21,3.16s-6.79,1-9,0-1.16-3.49-1.16-3.49l.39-3.19-4.17,2.11s-6.12,4.57-7.23,4.1A1.81,1.81,0,0,1,418.39,271.16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.41,269.41s3.91-2,4.91-1.1-1.4,5.06-2.45,5.08",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87,273.39c0-.05.14-.06.35-.24a5.09,5.09,0,0,0,.75-.89,10.75,10.75,0,0,0,.85-1.54,3.78,3.78,0,0,0,.45-2c0-.29-.27-.39-.6-.43a3.58,3.58,0,0,0-1,.08,12.17,12.17,0,0,0-1.7.49,7.23,7.23,0,0,1-1.58.5,4.27,4.27,0,0,1,1.44-.85,10.73,10.73,0,0,1,1.73-.61,4,4,0,0,1,1.13-.12,1,1,0,0,1,.32.06.78.78,0,0,1,.33.14.89.89,0,0,1,.42.62,4,4,0,0,1-.52,2.28,8.67,8.67,0,0,1-1,1.55,3.75,3.75,0,0,1-.94.84C437.06,273.47,436.85,273.42,436.87,273.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.32,259.48c-.32.47-6.5,12.63-6.5,12.63a2,2,0,0,0,3.31,0c1.74-2.06,6-6.8,6-6.8s4.9-3.05,4.74-5.05",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.87,260.26s0,0,0,.13a1.09,1.09,0,0,1,0,.38,3.37,3.37,0,0,1-.67,1.31,16.57,16.57,0,0,1-3.95,3.41l0,0-3.05,3.5-1.72,2-.9,1a5.13,5.13,0,0,1-1.06,1,2,2,0,0,1-1.65.22,2.9,2.9,0,0,1-1.3-.92l-.1-.12.08-.15c1.86-3.59,3.52-6.74,4.72-9,.58-1,1.05-1.92,1.44-2.62a4.11,4.11,0,0,1,.57-.91,4.63,4.63,0,0,1-.42,1l-1.3,2.7c-1.13,2.28-2.72,5.45-4.56,9l0-.27a2.43,2.43,0,0,0,1,.74,1.43,1.43,0,0,0,1.22-.18,4.7,4.7,0,0,0,1-.9l.9-1,1.74-1.95,3.11-3.47,0,0h0a18.18,18.18,0,0,0,4-3.21,3.78,3.78,0,0,0,.74-1.19A4.41,4.41,0,0,1,445.87,260.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,282.72c3.22,0,3.22-5,0-5s-3.22,5,0,5Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,282.72c3.22,0,3.22-5,0-5s-3.22,5,0,5Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,282.72c3.22,0,3.22-5,0-5s-3.22,5,0,5Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,282.72c3.22,0,3.22-5,0-5s-3.22,5,0,5Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,282.72c3.22,0,3.22-5,0-5s-3.22,5,0,5Z",
    style: {
      fill: "#132D8C"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnish);
export default __webpack_public_path__ + "static/media/Furnish.fd9901c89af62f5561ab4c6074840e62.svg";
export { ForwardRef as ReactComponent };